import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-2 items-center" }
const _hoisted_2 = { class: "w-6 flex-shrink-0" }
const _hoisted_3 = ["src", "title"]
const _hoisted_4 = { class: "text-black-light text-sm w-48 truncate" }
const _hoisted_5 = { class: "flex gap-2 flex-shrink-0" }
const _hoisted_6 = { class: "text-black-light text-sm" }
const _hoisted_7 = { class: "flex gap-2 flex-shrink-0" }
const _hoisted_8 = { class: "text-grey-dark text-sm" }
const _hoisted_9 = { class: "text-black-light text-sm" }
const _hoisted_10 = { class: "flex gap-2 flex-shrink-0" }
const _hoisted_11 = { class: "text-grey-dark text-sm" }
const _hoisted_12 = { class: "text-black-light text-sm" }
const _hoisted_13 = { class: "flex gap-2 flex-shrink-0" }
const _hoisted_14 = { class: "text-grey-dark text-sm" }
const _hoisted_15 = { class: "text-black-light text-sm" }
const _hoisted_16 = { class: "flex gap-2 flex-shrink-0" }
const _hoisted_17 = { class: "text-grey-dark text-sm" }
const _hoisted_18 = { class: "text-black-light text-sm" }
const _hoisted_19 = { class: "flex gap-2 text-sm text-left" }
const _hoisted_20 = { class: "text-grey-dark text-sm" }
const _hoisted_21 = { class: "text-black-light text-sm" }
const _hoisted_22 = { class: "text-primary-darkest text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_arrow = _resolveComponent("icon-arrow")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["md:hidden p-2 gap-2 flex-shrink-0 flex flex-col bg-white-dark hover:bg-grey-lightest rounded-md cursor-pointer overflow-hidden", `${
            _ctx.isOpen ? 'max-h-96' : 'max-h-10'
        } border-l-2 transform transition-all ${
            _ctx.editNorm.id == _ctx.item.id
                ? 'border-primary bg-grey-lightest hover:bg-grey-lighter'
                : 'border-transparent'
        }`]),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex border-b w-full pb-2 justify-between items-center", `${_ctx.isOpen ? 'border-grey-lighter' : 'border-transparent'}`])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.item.state_icon_url,
            alt: "status",
            title: _ctx.item.state_label
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.item.type_short_name) + " - " + _toDisplayString(_ctx.item.number), 1)
      ]),
      _createVNode(_component_icon_arrow, {
        class: _normalizeClass(`${
                    _ctx.isOpen ? 'rotate-180' : ''
                } transform transition-all flex-shrink-0`)
      }, null, 8, ["class"])
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-grey-dark text-sm" }, "#", -1)),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.item.index), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("policy")), 1),
      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.item.policy_short_names), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("state")), 1),
      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.item.status_short_name), 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("type")), 1),
      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.item.type_short_name), 1)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("number")), 1),
      _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.item.number), 1)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("title")), 1),
      _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.item.name), 1)
    ]),
    _createElementVNode("div", {
      class: "w-full border-t border-grey-lighter flex items-center justify-center pt-2 mt-2",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('openDetails')), ["stop"]))
    }, [
      _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("open_details")), 1)
    ])
  ], 2))
}